import { useIntl } from 'react-intl';

import WorkOrdersListModal from '@/components/_common/WorkOrdersListModal';
import { useDisclosure } from '@/hooks';
import { WorkOrderComplementStatusNumber } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import moment from 'moment';
import { DateTimeFormat } from '@/utils/moment';

import {
  StatisticDashboardModule,
  StatisticDashboardTypeColor,
} from '@/components/_common/StatisticDashboard';
import DashboardStatisticCard from '../../DashboardStatisticCard';

interface Props {
  value?: number;
}

function DelayedDeliveries({ value }: Props) {
  const intl = useIntl();
  const [viewWorkOrdersOpen, viewWorkOrdersActions] = useDisclosure();

  return (
    <>
      <DashboardStatisticCard
        tooltipTitle="Quantidade de orçamento com data de saída prevista anterior ao mês atual onde o orçamento ainda está em aberto e autorizado."
        statisticTitle={intl.formatMessage({
          id: 'dashboard.delayedDeliveries',
        })}
        color={StatisticDashboardTypeColor.expense}
        value={value}
        module={StatisticDashboardModule.workOrder}
        onClick={viewWorkOrdersActions.open}
      />

      <WorkOrdersListModal
        open={viewWorkOrdersOpen}
        onCancel={viewWorkOrdersActions.close}
        queryFilter={{
          status: [
            WorkOrderComplementStatusNumber.Open,
            WorkOrderComplementStatusNumber.Authorized,
          ],
          estimatedLeaveFinalDate: moment()
            .subtract(1, 'day')
            .format(DateTimeFormat),
        }}
      />
    </>
  );
}

export default DelayedDeliveries;
